(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-typewriter-wrapper]';

    function initTypewriter(wrapper) {
      if (!wrapper) return;

      if (wrapper.dataset.typewriterReady === 'true') {
        return;
      }

      const allowMobile =
        wrapper.dataset.typewriterMobile === 'true';

      const isMobile =
        window.matchMedia('(max-width: 749px)').matches;

      /*
       * Si está en móvil y la opción móvil está apagada,
       * dejamos el texto completamente normal.
       */
      if (isMobile && !allowMobile) {
        return;
      }

      const textBlock =
        wrapper.querySelector('.text-block') ||
        wrapper.querySelector('p');

      if (!textBlock) {
        return;
      }

      /*
       * Protección adicional:
       * nunca animar encabezados.
       */
      if (
        textBlock.matches(
          'h1, h2, h3, h4, h5, h6'
        )
      ) {
        return;
      }

      const headingInside =
        textBlock.querySelector(
          'h1, h2, h3, h4, h5, h6'
        );

      /*
       * Si el contenido completo es básicamente
       * un encabezado, tampoco lo animamos.
       */
      if (
        headingInside &&
        textBlock.children.length === 1
      ) {
        return;
      }

      const walker =
        document.createTreeWalker(
          textBlock,
          NodeFilter.SHOW_TEXT,
          {
            acceptNode(node) {
              const parent =
                node.parentElement;

              if (!parent) {
                return NodeFilter.FILTER_REJECT;
              }

              /*
               * No escribir texto perteneciente
               * a H1-H6.
               */
              if (
                parent.closest(
                  'h1, h2, h3, h4, h5, h6'
                )
              ) {
                return NodeFilter.FILTER_REJECT;
              }

              if (
                node.nodeValue &&
                node.nodeValue.trim().length > 0
              ) {
                return NodeFilter.FILTER_ACCEPT;
              }

              return NodeFilter.FILTER_REJECT;
            }
          }
        );

      const textNodes = [];

      while (walker.nextNode()) {
        textNodes.push({
          node: walker.currentNode,
          text: walker.currentNode.nodeValue
        });
      }

      if (!textNodes.length) {
        return;
      }

      wrapper.dataset.typewriterReady = 'true';

      const speed =
        parseInt(
          wrapper.dataset.typewriterSpeed,
          10
        ) || 55;

      /*
       * Primero vaciamos únicamente los nodos
       * que sí van a ser animados.
       */
      textNodes.forEach((item) => {
        item.node.nodeValue = '';
      });

      const lastTextNode =
        textNodes[textNodes.length - 1].node;

      const cursor =
        document.createElement('span');

      cursor.className =
        'typewriter-cursor';

      cursor.setAttribute(
        'aria-hidden',
        'true'
      );

      if (lastTextNode.parentElement) {
        lastTextNode.parentElement.appendChild(
          cursor
        );
      }

      let nodeIndex = 0;
      let characterIndex = 0;
      let started = false;

      function typeNextCharacter() {
        if (
          nodeIndex >= textNodes.length
        ) {
          return;
        }

        const current =
          textNodes[nodeIndex];

        current.node.nodeValue =
          current.text.substring(
            0,
            characterIndex + 1
          );

        characterIndex++;

        if (
          characterIndex >=
          current.text.length
        ) {
          nodeIndex++;
          characterIndex = 0;
        }

        if (
          nodeIndex < textNodes.length
        ) {
          setTimeout(
            typeNextCharacter,
            speed
          );
        }
      }

      function startTyping() {
        if (started) {
          return;
        }

        started = true;

        setTimeout(() => {
          typeNextCharacter();
        }, 250);
      }

      /*
       * Empieza solamente cuando el bloque
       * aparece en pantalla.
       */
      if (
        'IntersectionObserver' in window
      ) {
        const observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach(
                (entry) => {
                  if (
                    entry.isIntersecting
                  ) {
                    startTyping();
                    observer.disconnect();
                  }
                }
              );
            },
            {
              threshold: 0.15
            }
          );

        observer.observe(wrapper);
      } else {
        startTyping();
      }
    }

    function initAll(root = document) {
      let wrappers = [];

      if (
        root.matches &&
        root.matches(selector)
      ) {
        wrappers.push(root);
      }

      if (root.querySelectorAll) {
        wrappers =
          wrappers.concat(
            Array.from(
              root.querySelectorAll(
                selector
              )
            )
          );
      }

      wrappers.forEach(
        initTypewriter
      );
    }

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initAll(document);
        }
      );
    } else {
      initAll(document);
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initAll(event.target);
      }
    );

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        initAll(event.target);
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
